import styled from 'styled-components';
import * as palette from 'config';

export interface NavigationDrawerStyledProps {
    width?: number;
}

export const NavItem = styled.div<{ marginTop?: string }>`
    text-decoration: none;
    display: initial;
    cursor: pointer;
    ${({ marginTop }) => marginTop && `margin-top: ${marginTop}`};

    &.active {
        background: ${({ theme }) => theme.palette.primary.dark};
    }
    &:hover {
        background: ${({ theme }) => theme.palette.primary.light};
    }
`;

export const NavigationDrawerContainer = styled.div<NavigationDrawerStyledProps>`
    height: 100%;
    color: ${({ theme }) => theme.palette.common.white};
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    width: ${({ width }) =>
        width ? `${width}px` : palette.NAVIGATION_DRAWER_WIDTH};
    background: ${({ theme }) => theme.palette.primary.dark};
    position: relative;
`;

export const List = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    height: 100%;
`;

export const Title = styled.span`
    font-size: ${palette.FONT_SIZE_XXXXL};
    line-height: ${palette.FONT_SIZE_XXXXL};
    font-weight: 900;
    align-items: center;
    justify-content: center;
    padding: 2.1875rem;
    max-width: 14rem;
`;

export const Handle = styled.aside`
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    width: 8px;
    cursor: col-resize;
    transform: translateX(50%);
    z-index: 10;

    &:hover {
        background-color: ${({ theme }) => theme.palette.primary.darker};
    }
`;
